import { render } from "./Users.vue?vue&type=template&id=714e92ba&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "./Users.vue?vue&type=style&index=0&id=714e92ba&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-714e92ba"

export default script